import { useState } from 'react';
import { iProps } from './SmartSendFilterBar';
import Sort from './Sort';
import { P2GGrid, SvgFilter, SvgSort, SvgAdd, P2GBox } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';
import SmartSendSoldHeaderRowXs from '../SmartSendSoldHeaderRowXs';
import Add from './Add';
import DebouncedInput from '../../DebouncedInput';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { MobileButtonBox } from './MobileButtonBox';

export function SmartSendFilterBarMobile(props: iProps) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [showSort, setShowSort] = useState(false);

  return (
    <>
      <P2GGrid container justify="center" gap={1} wrap="nowrap" alignItems="center">
        <P2GGrid item flexGrow={1}>
          <DebouncedInput
            fullWidth
            id="Search"
            label={t('SEARCH_INPUT_LABEL', { defaultValue: 'Find by order details...' })}
            value={props.filter.SearchTerm}
            onChange={(v) => props.update({ ...props.filter, SearchTerm: v })}
            disabled={props.filter.DisableFilter}
          />
        </P2GGrid>
        {!props.filter.DisableFilter && (
          <P2GGrid item flexShrink={1}>
            <MobileButtonBox>
              <CdnIconProxy
                src="/theme/icons/Filter.svg"
                size="xs"
                palette={props.activeFilters > 2 ? 'success' : 'primary'}
                onClick={props.openFilter}
              >
                <SvgFilter />
              </CdnIconProxy>
            </MobileButtonBox>
          </P2GGrid>
        )}
        <P2GGrid item flexShrink={1}>
          <MobileButtonBox>
            <CdnIconProxy
              src="/theme/icons/Sort.svg"
              size="xs"
              palette="primary"
              onClick={() => {
                setShowSort(true);
              }}
            >
              <SvgSort />
            </CdnIconProxy>
          </MobileButtonBox>
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <Add>
            <MobileButtonBox>
              <CdnIconProxy src="/theme/icons/Add.svg" size="xs" palette="primary">
                <SvgAdd />
              </CdnIconProxy>
            </MobileButtonBox>
          </Add>
        </P2GGrid>
      </P2GGrid>
      <P2GBox py={2}>
        <SmartSendSoldHeaderRowXs
          filterKey={props.filterKey}
          selected={props.summary.selected.length}
          total={props.summary.count}
        />
      </P2GBox>
      <P2GSidePanel open={showSort} onClose={() => setShowSort(false)} anchor="bottom">
        <Sort actions={props.actions} filter={props.filter} update={props.update} isXs={props.isXs}></Sort>
      </P2GSidePanel>
    </>
  );
}
